<header
  #trigger="cdkOverlayOrigin"
  [class]="computedHeaderClass()"
  [ngClass]="[
    fixed() ? 'fixed' : 'sticky',
    lightMode() ? '' : 'bg-transparent text-white',
    scrollPosition() > 300 ? 'scrolled' : 'pinned',
    headernav.isOpen() || langSelectDropdown.isOpen() ? 'open' : ''
  ]"
  cdkOverlayOrigin
>
  <button
    [ngClass]="displayHamburger() ? 'block' : 'hidden'"
    class="h-12 w-12 flex-shrink-0 rounded-full md:hidden"
    type="button"
    (click)="sidenav.toggle()"
    matRipple
  >
    <sheba-hamburger-icon />
  </button>
        <a
        class="block h-12 w-12 flex-shrink-0 rounded-full md:hidden"
        type="button"
        href="/"
        aria-label="Home"
        routerLinkDetector
        attr.aria-label="{{ 'HEADER.HOME_ARIA_LABEL' | translate }}"
        matRipple
      >
        <sheba-home-icon />
      </a>

  <div class="mx-auto flex h-10 w-auto items-center max-md:flex-grow md:!mx-0 md:h-14">
    <a
      class="relative h-full max-h-[2.5rem] w-full cursor-pointer px-2 hover:bg-gray-200 md:max-h-[3.563rem] md:w-[17.125rem]"
      [href]="(headerData().logoLink?.url ?? headerData().logoLink?.route?.path) | sanitizeUrl"
      [attr.target]="headerData().logoLink?.target"
      [attr.aria-description]="headerData().logoLink?.title"
      routerLinkDetector
      cdkMenuItem
      matRipple
    >
      @if (headerData().logo && headerData().logo!.image) {
        <img
          class="absolute inset-0 h-full w-full object-contain object-center md:object-left md:rtl:object-right"
          [ngSrc]="headerData().logo!.image.url | cmsMediaPrefix"
          [alt]="headerData().logo.alt ?? ''"
          [title]="headerData().logo.title ?? ''"
          [ngClass]="{ 'brightness-0 invert': !lightMode() }"
          [width]="100"
          [height]="100"
        />
      }
    </a>
  </div>

  <div class="mx-auto hidden gap-6 md:flex">
    <sheba-headernav #headernav="headernav" [menu]="displayMenu() ? headerData().menu : undefined" [overlayOrigin]="trigger" />
  </div>

  <div class="contents place-items-center gap-3 md:flex xl:me-[10.1875rem]">
    <div class="contents place-items-center gap-2 md:flex">
      <a
        class="!hidden flex-shrink-0 md:block lg:!flex"
        type="button"
        [href]="(headerData().privateAreaLink?.url ?? headerData()?.privateAreaLink?.route?.path) | sanitizeUrl"
        [attr.target]="headerData().privateAreaLink?.target"
        [attr.aria-description]="headerData().privateAreaLink?.title"
        shButton
        color="black"
        header
        outline
        routerLinkDetector
      >
        <span class="truncate">
          {{ 'HEADER.PERSONAL_AREA' | translate }}
        </span>
      </a>
      <a
        class="mat-ripple h-12 w-12 flex-shrink-0 rounded-full md:block lg:hidden"
        type="button"
        [href]="headerData()?.privateAreaLink?.route?.path ?? headerData()?.privateAreaLink?.url"
        [attr.target]="headerData().privateAreaLink?.target"
        [attr.aria-description]="headerData().privateAreaLink?.title"
        routerLinkDetector
        matRipple
      >
        <span class="sr-only">
          {{ 'HEADER.PERSONAL_AREA' | translate }}
        </span>
        <sheba-profile-icon />
      </a>
      <sheba-lang-select-dropdown #langSelectDropdown="langSelectDropdown" />
    </div>

    <div class="contents place-items-center gap-2 md:flex">
      <sheba-search-header [overlayOrigin]="trigger" />
      @if (!isHomePage()) {
        <a
          class="hidden h-12 w-12 flex-shrink-0 rounded-full md:block"
          href="/"
          routerLinkDetector
          [attr.aria-label]="'HEADER.HOME_ARIA_LABEL' | translate"
          [matTooltip]="'HEADER.HOME_ARIA_LABEL' | translate"
          matRipple
        >
          <sheba-home-icon />
        </a>
      }
    </div>
  </div>
</header>

<sheba-sidenav #sidenav [menu]="headerData().menu" />
